module.exports = __webpack_public_path__ + "static/media/start-carousel-read.03641727.jpg";